import GroupList from "../components/Groups/GroupsList"

const GroupsListView = () => <GroupList />

export default GroupsListView